import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const Layout = ({ children }) => {
  const location = useLocation();
  const isDebugPage = location.pathname.startsWith('/debug');

  return (
    <div className="min-h-screen bg-gray-50">
      {!isDebugPage && <Header />}
      <main className={isDebugPage ? "p-8" : "pt-20"}>
        {children}
      </main>
    </div>
  );
};

export default Layout;